<template>
  <!-- 页面容器 -->
  <div class="page-container">
    <!-- 预约客户卡片 -->
    <div class="page-card">
      <!-- 搜索栏 -->
      <div class="page-card__header">
        <span style="font-weight: bold">预约客户</span>
      </div>

      <!-- 数据表格 -->
      <div class="page-card__body">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="编号" width="50"> </el-table-column>

          <el-table-column prop="wxuser.avatarurl" label="头像" width="80">
            <template slot-scope="scope">
              <el-image :src="logourl + scope.row.wxuser.avatarurl" style="width: 30px">
                <div slot="error">
                  <i class="el-icon-picture-outline" style="font-size: 30px"></i>
                </div>
              </el-image>
            </template>
          </el-table-column>

          <el-table-column prop="wxuser.name" label="姓名" width="100">
          </el-table-column>

          <el-table-column prop="wxuser.company" label="公司名称"> </el-table-column>

          <el-table-column prop="wxuser.position" label="职务" width="100">
          </el-table-column>

          <el-table-column prop="wxuser.phone_number" label="电话" width="150">
          </el-table-column>

          <el-table-column
            prop="create_time"
            label="时间"
            width="160"
            sortable
          ></el-table-column>
        </el-table>
      </div>

      <!-- 分页器 -->
      <div class="pagination-wrap" v-if="tableData.length !== 0">
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="pagesize"
          :total="aSum"
          :page-count="pageCount"
          :current-page.sync="currentPage"
          background
          layout="prev, pager, next,jumper"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../utils/api";

export default {
  name: "reserveList",
  data() {
    return {
      tableData: [],
      //分页
      // 总条目数 total
      aSum: 0,
      // 当前页数 currenr_page
      currentPage: 1,
      // 总页数 num_pages
      pageCount: 1,
      // 每页显示条目数 pagesize
      pagesize: 10,
      logourl:
        "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/avatar/",
    };
  },
  mounted() {
    this.reserveList();
  },
  methods: {
    /** 获取预约客户列表 */
    reserveList() {
      let userid = localStorage.getItem("userid");
      let url = this.baseUrl + "/user/reserves/?user=" + userid;
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = 1;
      });
    },

    /** 分页切换 */
    handleCurrentChange(val) {
      let userid = localStorage.getItem("userid");
      let url =
        this.baseUrl + "/user/reserves/?user=" + userid + "&page=" + val;
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = val;
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/manage/reserveList.vue